class DayPicker extends HTMLElement {
  constructor() {
    super();
    const days = this.querySelectorAll('.days .day');
    const firstDay = days[0];
    const firstDate = firstDay.getAttribute('data-formated');
    localStorage.setItem('firstDeliveryDate', firstDate);
  }

  static get observedAttributes() {
    return ["data-selected", "data-day-de", "data-day-en"];
  }

  connectedCallback() {
    const storedDeliveryDate = localStorage.getItem('lastSelectedDeliveryDate') || null;
    if(storedDeliveryDate == null) {
      const days = this.querySelectorAll('.days .day');
      const firstDay = days[0];
      const firstDate = firstDay.getAttribute('data-formated');
      localStorage.setItem('lastSelectedDeliveryDate', firstDate);

    } else {
      setTimeout(()=> {
        const storedDeliveryDate = localStorage.getItem('lastSelectedDeliveryDate') || null;
        this.querySelector(`[js-selected-day="target"]`).innerText = `${storedDeliveryDate}`;
        this.setAttribute('data-selected', storedDeliveryDate)
      },1000)
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let _selected = this.getAttribute("data-selected");
    let _day = this.getAttribute("data-day-de");
    let _day_english = this.getAttribute("data-day-en");

    if (name == "data-selected") {
      if (oldValue != null) {
        this.setDeliveryDate(_selected);
      }
    } else if (name == "data-day-en") {
      this.refreshDay(_day, _day_english);
    }
  }

  // runs everytime a new options is selected
  updateDeliveryDate = (d, day) => {
    let _day = day.split("|");
    this.setAttribute("data-selected", d);
    this.setAttribute("data-day-de", _day[0]);
    this.setAttribute("data-day-en", _day[1]);
    this.setAttribute("data-day-fr", _day[2]);
  };

  // visually update the selected date on the form
  refreshDay(d, d_en) {
    const storedDeliveryDate = localStorage.getItem('lastSelectedDeliveryDate') || null;

    // console.log('right before we set: ', d_en);
    this.querySelector(`[js-selected-day="target"]`).setAttribute("data-day", d_en);
    this.querySelector(`[js-selected-day="target"]`).innerText = `${storedDeliveryDate}`;
  }

  // Save the selected loading date
  setDeliveryDate(d) {
    this.loadingState(d);
    localStorage.setItem("lastSelectedDeliveryDate", d);
    this.hydrateItems(d);
  }

  // disables buttons inbetween loading phases
  loadingState(d) {
    document
      .querySelector(`[js-payment-options="loader"]`)
      .classList.remove("visually-hidden");
    document
      .querySelector(".modal-bottom__main-payment")
      .classList.add("is-loading");
    this.querySelectorAll(`box-date:not([data-formated="${d}"])`).forEach(
      (el) => {
        el.classList.remove("selected");
        el.classList.add("disabled");
      },
    );
    this.querySelector(`[data-formated="${d}"]`).classList.add("selected");

    setTimeout(() => {
      this.querySelectorAll(`box-date:not([data-formated="${d}"])`).forEach(
        (el) => {
          el.classList.remove("disabled");
        },
      );
      document
        .querySelector(`[js-payment-options="loader"]`)
        .classList.add("visually-hidden");
      document
        .querySelector(".modal-bottom__main-payment")
        .classList.remove("is-loading");
    }, 1000);
  }

  hydrateItems(d) {
    const EventUpdateCart = new CustomEvent("TriggerUpdateCart", {
      bubbles: true,
      detail: {
        'sheduled': d,
      }
    });

    window.dispatchEvent(EventUpdateCart);
  }
}

customElements.define("day-picker", DayPicker);

class BoxDate extends HTMLElement {
  constructor() {
    super();

    const ref = document.querySelector(`[ref="day-picker"]`);

    this.addEventListener("click", (e) => {
      e.preventDefault();
      const date = this.getAttribute("data-formated");
      const day = this.getAttribute("data-day");

      ref.updateDeliveryDate(date, day);
    });
  }
}

customElements.define("box-date", BoxDate);
